import script from "./IrregularUpdateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./IrregularUpdateModal.vue?vue&type=script&setup=true&lang=ts"

import "./IrregularUpdateModal.vue?vue&type=style&index=0&id=23d7ad74&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23d7ad74"]])

export default __exports__